import moment from 'moment'
import { WeekBoundaries } from '@/types'

export function getWeekBoundaries (date: Date): WeekBoundaries {
  return {
    start: moment(date).isoWeekday(1).toDate(),
    end: moment(date).isoWeekday(7).toDate()
  }
}

export function formatAsIsoWeek(date: Date): string {
  return moment(date).format('GGGG[W]WW')
}
